import { observer } from 'mobx-react';
import createPermissionFeatureWithoutStoreHook from '../../hooks/CreatePermissionFeatureWithoutStoreHook';
import { SingleTenantId } from '../../../../../base/Constants';
export default function createSingleTenantPermissionFeatureComponent(permissionEnum) {
    var usePermissionFeatureWithoutStoreHook = createPermissionFeatureWithoutStoreHook()(permissionEnum);
    var permissionFeatureWithoutStoreComponent = function (_a) {
        var children = _a.children, requiredPermission = _a.requiredPermission, requiredPermissions = _a.requiredPermissions;
        var _b = usePermissionFeatureWithoutStoreHook(), hasPermission = _b.hasPermission, hasPermissions = _b.hasPermissions;
        if (requiredPermission && hasPermission(SingleTenantId, requiredPermission)) {
            return children;
        }
        if (requiredPermissions && hasPermissions(SingleTenantId, requiredPermissions)) {
            return children;
        }
        return null;
    };
    return observer(permissionFeatureWithoutStoreComponent);
}
//# sourceMappingURL=SingleTenantPermissionFeatureComponentCreator.js.map